var module = angular.module('octopusApp.shared');

module.directive('eventListing', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      events: '='
    },
    templateUrl: 'areas/shared/views/event-listing.html',
    link: function (scope, element, attrs) {
    },
    controller: function($scope, eventFormatter) {
      $scope.skip = 0;
      $scope.formatMessageHtml = eventFormatter.format;
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/event_listing.js
// module id = 6275014679128082
// module chunks = 1